export default __webpack_public_path__ + "assets/eeecb5555ac344b3c55131a3c2fcc4a2.png";